import React, { lazy, Suspense } from "react";
import "./App.scss";
import Bars from "./components/Bars/Bars.js";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import Home from "./containers/Home/Home.js";
import Kalendar from "./containers/Kalendar/Kalendar";
import Manastiri from "./containers/Manastiri/Manastiri";
import Ikone from "./containers/Ikone/Ikone";
import IkoneKategorija from "./containers/Ikone/IkoneKategorija";
import Prodavnica from "./containers/Prodavnica/Prodavnica";
import IkonaDetalj from "./containers/Prodavnica/IkonaDetalj";
import Kontakt from "./containers/Kontakt/Kontakt";
import SinglePost2 from "./containers/SinglPost/SinglePost2";
import ScrollToTop from "./UI/ScrollToTop/ScrollToTop";
import HeadHelmet from "./components/HeadHelmet/HeadHelmet";
import { LocationProvider } from "./shared/LocationContext";
import withIdProvider from "./shared/HOC";
import { CartProvider } from "./shared/CartContext";
import { AuthProvider, useAuth } from "./shared/AuthContext";
import Korpa from "./containers/Korpa/Korpa";
import AdminLogin from "./containers/Admin/AdminLogin";
import AdminDashboard from "./containers/Admin/AdminDashboard";

const Footer = lazy(() => import("./components/Footer/Footer.js"));

function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading) return null;
  if (!user) { window.location.href = "/admin/login"; return null; }
  return children;
}

export default function App() {
  return (
    <Router>
      <AuthProvider>
        <CartProvider>
          <Routes>
            {/* Admin rute — bez Bars/Footer */}
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin" element={
              <ProtectedRoute><AdminDashboard /></ProtectedRoute>
            } />

            {/* Javne rute */}
            <Route path="*" element={
              <LocationProvider>
                <HeadHelmet />
                <ScrollToTop />
                <div className="app">
                  <Bars />
                  <div className="app-wrapper">
                    <Routes>
                      <Route path="/" element={React.createElement(withIdProvider(Home))} />
                      <Route path="/ikone" element={React.createElement(withIdProvider(Ikone))} />
                      <Route path="/ikone/:kategorija" element={React.createElement(withIdProvider(IkoneKategorija))} />
                      <Route path="/prodavnica" element={React.createElement(withIdProvider(Prodavnica))} />
                      <Route path="/prodavnica/:slug" element={React.createElement(withIdProvider(IkonaDetalj))} />
                      <Route path="/kontakt" element={React.createElement(withIdProvider(Kontakt))} />
                      <Route path="/korpa" element={React.createElement(withIdProvider(Korpa))} />
                      <Route path="/crkveni-kalendar" element={React.createElement(withIdProvider(Kalendar))} />
                      <Route path="/crkveni-kalendar/:slug/:id/" element={React.createElement(withIdProvider(Kalendar))} />
                      <Route path="/ostalo/:slug" element={React.createElement(withIdProvider(SinglePost2))} />
                      <Route path="/manastiri" element={React.createElement(withIdProvider(Manastiri))} />
                      <Route path="/manastirske-price/:id" element={React.createElement(withIdProvider(SinglePost2))} />
                      <Route path="/slave" element={React.createElement(withIdProvider(SinglePost2))} />
                    </Routes>
                  </div>
                </div>
                <Suspense fallback={<div></div>}>
                  <Footer />
                </Suspense>
              </LocationProvider>
            } />
          </Routes>
        </CartProvider>
      </AuthProvider>
    </Router>
  );
}
